// Central content + asset config for the SmartBallot landing site.
export const BRAND = {
  name: "SmartBallot",
  domain: "smartballot.app",
  tagline: "The smart way to run a vote.",
  blurb: "Helping Indigenous Communities plan, cost, and run their voting events with confidence.",
};

export const ASSETS = {
  community:
    "https://images.unsplash.com/photo-1527525443983-6e60c75fff46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjBnYXRoZXJpbmclMjBoYW5kcyUyMHRvZ2V0aGVyfGVufDB8fHx8MTc4NTIwOTE5MXww&ixlib=rb-4.1.0&q=85",
  heroShot: "/smartballot-inuse.png",
  costShot: "/smartballot-cost.png",
  recipientShot: "/smartballot-recipient.png",
  proposalShot: "/smartballot-proposal.png",
};

export const NAV = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Vote-Estimate", href: "#vote-estimate" },
  { label: "Contact", href: "#contact" },
];

// External application entry points (secured apps, hosted separately).
export const LINKS = {
  voteEstimate: "https://vote-estimate.emergent.host/",
  electionHub: "https://fnp-election-hub.emergent.host/",
};

export const MARQUEE = [
  "Proposals in minutes",
  "Budget-ready",
  "Built for Indigenous Communities",
  "Run smarter votes",
  "Clarity before the ballot",
  "Confidence at the ballot box",
  "Coast to coast to coast",
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Made for the Indigenous community",
    body:
      "Every election starts with people. SmartBallot is built around the way real Indigenous Communities plan and decide \u2014 respecting your process, your timeline, and every voice at the table.",
  },
  {
    no: "02",
    title: "Clarity before the vote",
    body:
      "A voting event is a huge undertaking. Vote-Estimate turns scattered notes into a costed, defensible proposal your team can act on today \u2014 not next quarter.",
  },
  {
    no: "03",
    title: "Confidence at the ballot box",
    body:
      "From first plan to final count, SmartBallot gives you the numbers and the structure to run a vote you can stand behind.",
  },
];
